import React from 'react';

import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { useIntl } from 'react-intl';

import messages from './messages';

const styles = () =>
  createStyles({
    embedErrorContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100vh',
      backgroundColor: '#F0F6F7',
      color: '#617988',
      fontSize: 18,
      fontWeight: 500,
    },
  });

interface EmbedErrorProps extends WithStyles<typeof styles> {}

const EmbedError: React.FC<EmbedErrorProps> = ({ classes }) => {
  const { formatMessage } = useIntl();
  return (
    <div className={classes.embedErrorContainer}>
      <div>{formatMessage(messages.description)}</div>
    </div>
  );
};

export default withStyles(styles)(EmbedError);
